import {Injectable} from '@angular/core';
import {StaticValuesUtils} from '../utils/static-values/static-values.utils';


@Injectable()
export class AbTestService {

    public isTestBranch(testName: string) {
        return StaticValuesUtils.getABTests()?.[testName]?.['branch'] === 'test';
    }

    public isCtrlBranch(testName: string) {
        return StaticValuesUtils.getABTests()?.[testName]?.['branch'] !== 'test';
    }
}